module.exports = __webpack_public_path__ + "static/media/iit-delhi-logo.1d22303f.png";